import { createSlice } from "@reduxjs/toolkit";
import { authState } from "../models/state/AuthState";

export const authSlice = createSlice({
  name: "auth",
  initialState: authState,
  reducers: {},
  extraReducers: (builder) => {},
});
